import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=3c0ad266&scoped=true"
import script from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=3c0ad266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ad266",
  null
  
)

export default component.exports